import { render, staticRenderFns } from "./FilesRequestsTab.vue?vue&type=template&id=615e1b96&scoped=true"
import script from "./FilesRequestsTab.vue?vue&type=script&lang=js"
export * from "./FilesRequestsTab.vue?vue&type=script&lang=js"
import style0 from "./FilesRequestsTab.vue?vue&type=style&index=0&id=615e1b96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615e1b96",
  null
  
)

export default component.exports